<!-- 控制风盘风柜表单 -->
<template>
    <div class='control-box'>
        <div class="control-title">
            <span>控制参数</span>
        </div>
        <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="90px" class="ruleForm">
            <el-form-item label="状态" prop="status">
                <el-select v-model="form.status" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.status"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模式" prop="module">
                <el-select v-model="form.module" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.pattern"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
            <template v-if="controlType === 2">
               <el-form-item label="制热温度" prop="heatingtemperture">
                    <el-input v-model="form.heatingtemperture" 
                        @blur="handleChangeInput('heatingtemperture')" 
                        clear 
                        placeholder="请输入制热温度"></el-input>&nbsp;&nbsp;°C
                </el-form-item>
                <el-form-item label="制冷温度" prop="cryogenictempertur">
                    <el-input v-model="form.cryogenictempertur"
                        @blur="handleChangeInput('cryogenictempertur')" 
                        clear placeholder="请输入制冷温度"></el-input>&nbsp;&nbsp;°C
                </el-form-item>
            </template>
            <template v-if="controlType === 1">
                <el-form-item label="设温" prop="setTemperature">
                    <el-input v-model="form.setTemperature"
                        @blur="handleChangeInput('setTemperature')"  
                        clear placeholder="请输入设温"></el-input>&nbsp;&nbsp;°C
                </el-form-item>
                <el-form-item label="风速" prop="windSpeed">
                    <el-select v-model="form.windSpeed" clearable placeholder="请选择">
                        <el-option
                            v-for="(v, i) in configData.windSpeed"
                            :key="i"
                            :label="v.label"
                            :value="v.value"
                            :disabled="v.disable">
                        </el-option>
                    </el-select>
                </el-form-item>
            </template>
            <el-form-item label="锁定" prop="lock">
                <el-select v-model="form.lock" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.lock"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="来电启动" prop="callstartstate">
                <el-select v-model="form.callstartstate" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.DDGK"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通风模式" prop="ventilationmodeenables">
                <el-select v-model="form.ventilationmodeenables" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.windMode"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button style="width:100%;" type="primary" @click="onSubmit">确认操作</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { CLUSTERMANA } from '@/api/configData.js'
import Service from '@/api/Service'
export default {
    name:  'CmpControl',
    props: ["controlType", "terminalid"],
    inject: ["reload"],
    data() {
        return {
            //  控制参数设置
            form: {
                status: '',             //  状态
                module: '',            //  模式
                heatingtemperture: '',         //  制热温度
                cryogenictempertur: '',        //  制冷温度
                windSpeed: '',          //  风速
                setTemperature: '',     //  设温
                lock: '',           //  锁定

                callstartstate: '',             // 来电启动   
                upperlimit: '',    //  温度下限
                lowerlimit: '',  //  温度上限
                ventilationmodeenables: '',   //  通风模式
            }, 
            // 参数设置校验
            rules: {

            },
            configData: CLUSTERMANA,
        };
    },

    methods: {
        // 温度输入框
        handleChangeInput(key, val) {
            let value = this.form[key];

            if(isNaN(value) || value<10 || val>50) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围10-50;"
                })
                this.form[key] = "";
            }
        },
        async onSubmit() {
            let form = Object.assign({},this.form);
            
            form.terminalid = this.terminalid
            form.devtype = this.controlType;

            let data = await Service.controlByTerminalID(form);
            if(data) {
                this.$notify({
                    title: '发送成功',
                    message: '操作指令已下发，由于设备实时状态上报有延迟，请等待页面实时数据刷新。',
                    type: 'success'
                });
                this.reload();
            }
        },
    }
}

</script>
<style lang='less' scoped>
    .control-box{
        width: 300px;
        position: absolute;
        top: 0;
        right: -300px;
        z-index: 99;
        .control-title{
            font-size: 16px;
            color: #2c3e50;
            font-weight: 400;
            margin-bottom: 10px;
            margin-left: 15px;
            overflow: hidden;
        }
    }
</style>